module.exports = __webpack_public_path__ + "static/media/ourstories-screen-two-people-pier.bf66df8b.png";